import React from 'react';
import PropTypes from 'prop-types';
import './styles.css';

function LocalLogo({ width, height, color = '' }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 40 26.83"
      width={width}
      height={height}
    >
      <defs>
        <linearGradient
          id="linear-gradient"
          x1="-12.01"
          y1="22.69"
          x2="-12.23"
          y2="26.09"
          gradientTransform="translate(45.74 -18.01) rotate(9.74)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#f40000" />
          <stop offset="1" stopColor="#c70505" />
        </linearGradient>
        <clipPath id="clip-path">
          <rect
            className="cls-1"
            fill="none"
            x="-152.27"
            y="-4453.42"
            width="2.85"
            height="15.36"
          />
        </clipPath>
        <clipPath id="clip-path-2">
          <rect
            className="cls-1"
            fill="none"
            x="-115.2"
            y="-4453.42"
            width="2.85"
            height="15.36"
          />
        </clipPath>
        <clipPath id="clip-path-3">
          <path
            className="cls-3"
            fill="none"
            clipRule="evenodd"
            d="M-125.9-4440.81a3,3,0,0,1,.24-1.23,2.83,2.83,0,0,1,.65-.94,2.88,2.88,0,0,1,.94-.63,4.89,4.89,0,0,1,1.18-.34l2.46-.37a.9.9,0,0,0,.59-.26.74.74,0,0,0,.17-.48,1.28,1.28,0,0,0-.42-.95,1.75,1.75,0,0,0-1.27-.41,1.79,1.79,0,0,0-1.37.5,2,2,0,0,0-.55,1.19l-2.4-.54a3.85,3.85,0,0,1,.37-1.23,4,4,0,0,1,.84-1.1,4.44,4.44,0,0,1,1.31-.79,4.94,4.94,0,0,1,1.79-.3,5.62,5.62,0,0,1,2,.34,3.79,3.79,0,0,1,1.36.87,3.32,3.32,0,0,1,.74,1.27,4.71,4.71,0,0,1,.23,1.5l0,5.13c0,.28,0,.58,0,.9a7.51,7.51,0,0,0,.08.75h-2.49a5.23,5.23,0,0,1-.06-.58c0-.25,0-.47,0-.67a3.52,3.52,0,0,1-1.12,1.08,3.33,3.33,0,0,1-1.84.45,3.61,3.61,0,0,1-1.43-.27,3.46,3.46,0,0,1-1.09-.7,3,3,0,0,1-.68-1A3.14,3.14,0,0,1-125.9-4440.81Zm4,1.06a3.18,3.18,0,0,0,.82-.11,1.79,1.79,0,0,0,.71-.4,2.22,2.22,0,0,0,.49-.74,3.38,3.38,0,0,0,.19-1.16v-.46l-2.26.35a1.65,1.65,0,0,0-.89.39,1.13,1.13,0,0,0-.36.92,1.23,1.23,0,0,0,.32.83A1.23,1.23,0,0,0-121.89-4439.75Z"
          />
        </clipPath>
        <clipPath id="clip-path-4">
          <path
            className="cls-3"
            fill="none"
            clipRule="evenodd"
            d="M-138-4445.41s0,0,0,0a5.19,5.19,0,0,0-1.09-1.75,5.06,5.06,0,0,0-1.67-1.16,5.51,5.51,0,0,0-2.08-.42,5.16,5.16,0,0,0-2.09.41,5,5,0,0,0-1.67,1.13,5.34,5.34,0,0,0-1.11,1.75,6.09,6.09,0,0,0-.41,2.22,6.07,6.07,0,0,0,.39,2.21,5.44,5.44,0,0,0,1.09,1.76,5.16,5.16,0,0,0,1.67,1.16,5.15,5.15,0,0,0,2.08.42,5.16,5.16,0,0,0,2.09-.41,4.91,4.91,0,0,0,1.68-1.14A5.42,5.42,0,0,0-138-4441s0,0,0,0a8,8,0,0,1-.29-2.16,8.2,8.2,0,0,1,.3-2.18m-2.55,3.46a2.7,2.7,0,0,1-.56.92,2.31,2.31,0,0,1-.82.56,2.65,2.65,0,0,1-1,.19,2.65,2.65,0,0,1-1-.2,2.4,2.4,0,0,1-.81-.56,2.85,2.85,0,0,1-.56-.93,3.6,3.6,0,0,1-.21-1.29,3.63,3.63,0,0,1,.22-1.29,2.8,2.8,0,0,1,.56-.92,2.31,2.31,0,0,1,.82-.56,2.44,2.44,0,0,1,1-.18,2.44,2.44,0,0,1,1,.19,2.44,2.44,0,0,1,.82.56,3,3,0,0,1,.55.93,3.63,3.63,0,0,1,.21,1.29,3.35,3.35,0,0,1-.22,1.29"
          />
        </clipPath>
        <clipPath id="clip-path-5">
          <path
            className="cls-3"
            fill="none"
            clipRule="evenodd"
            d="M-131.53-4446.12a2.44,2.44,0,0,0-1,.18,2.27,2.27,0,0,0-.81.56,2.62,2.62,0,0,0-.55.92,3.49,3.49,0,0,0-.21,1.25,3.53,3.53,0,0,0,.2,1.25,2.67,2.67,0,0,0,.55.93,2.32,2.32,0,0,0,.82.58,2.45,2.45,0,0,0,1,.19,2.59,2.59,0,0,0,.91-.15,2.42,2.42,0,0,0,.68-.41,2.06,2.06,0,0,0,.46-.57,2.93,2.93,0,0,0,.26-.62l2.38.84a4.47,4.47,0,0,1-.55,1.28,4.28,4.28,0,0,1-1,1.12,5,5,0,0,1-1.39.8,5,5,0,0,1-1.79.3,5.27,5.27,0,0,1-2.06-.43,4.91,4.91,0,0,1-1.68-1.16,5.44,5.44,0,0,1-1.11-1.75,5.87,5.87,0,0,1-.4-2.21,6,6,0,0,1,.41-2.23,5.21,5.21,0,0,1,1.1-1.74,5.23,5.23,0,0,1,1.66-1.14,5.12,5.12,0,0,1,2-.4,4.92,4.92,0,0,1,1.82.32,4.78,4.78,0,0,1,1.4.8,4,4,0,0,1,1,1.12,5.27,5.27,0,0,1,.52,1.3l-2.42.83a3,3,0,0,0-.7-1.21,2,2,0,0,0-1.52-.55"
          />
        </clipPath>
        <clipPath id="clip-path-6">
          <rect
            className="cls-1"
            fill="none"
            x="-152.27"
            y="-4453.25"
            width="95.83"
            height="23.83"
          />
        </clipPath>
      </defs>
      <title>XMas Logo</title>
      <g className="cls-4" isolation="isolate">
        <g id="Layer_1" data-name="Layer 1">
          <path
            className={`LocalsearchLogo__st1${color}`}
            d="M8.92,16.22v-11h2v11Z"
          />
          <path
            className={`LocalsearchLogo__st1${color}`}
            d="M36.29,16.22v-11h2v11Z"
          />
          <path
            className={`LocalsearchLogo__st1${color}`}
            d="M28.53,14.15a2.07,2.07,0,0,1,.18-.88,2,2,0,0,1,.47-.67,2.38,2.38,0,0,1,.71-.45,4,4,0,0,1,.87-.24l1.83-.27a.7.7,0,0,0,.44-.18.48.48,0,0,0,.13-.34.91.91,0,0,0-.31-.69,1.66,1.66,0,0,0-2,.07,1.33,1.33,0,0,0-.4.85L28.69,11a2.57,2.57,0,0,1,.28-.88,2.7,2.7,0,0,1,.62-.78,3.17,3.17,0,0,1,1-.56,3.69,3.69,0,0,1,1.34-.22,4.35,4.35,0,0,1,1.49.24,2.81,2.81,0,0,1,1,.63,2.33,2.33,0,0,1,.55.9,3,3,0,0,1,.17,1.08V15c0,.2,0,.42,0,.64s0,.41,0,.54H33.35a3,3,0,0,1-.05-.41,4.19,4.19,0,0,1,0-.48,2.69,2.69,0,0,1-.83.77,2.6,2.6,0,0,1-1.37.33,3,3,0,0,1-1.07-.2,2.52,2.52,0,0,1-.81-.5,2.14,2.14,0,0,1-.5-.71A2.05,2.05,0,0,1,28.53,14.15Zm3,.76a2.49,2.49,0,0,0,.61-.08,1.27,1.27,0,0,0,.52-.29A1.3,1.3,0,0,0,33,14a2.12,2.12,0,0,0,.14-.82v-.33l-1.68.25a1.4,1.4,0,0,0-.66.27.81.81,0,0,0-.27.66.88.88,0,0,0,.24.6A.92.92,0,0,0,31.51,14.91Z"
          />
          <path
            className={`LocalsearchLogo__st1${color}`}
            d="M19.53,10.87v0a4,4,0,0,0-.81-1.25,3.78,3.78,0,0,0-1.24-.82,4,4,0,0,0-1.55-.3,4,4,0,0,0-1.55.29,3.65,3.65,0,0,0-1.25.81,3.78,3.78,0,0,0-.82,1.24,4.17,4.17,0,0,0-.3,1.59A4.09,4.09,0,0,0,12.29,14a3.74,3.74,0,0,0,.81,1.25,3.8,3.8,0,0,0,1.24.83,3.93,3.93,0,0,0,1.55.3,4,4,0,0,0,1.55-.29,3.63,3.63,0,0,0,1.24-.82A3.85,3.85,0,0,0,19.51,14a0,0,0,0,1,0,0,5.69,5.69,0,0,1,0-3.1Zm-1.9,2.47a1.87,1.87,0,0,1-.42.66,1.73,1.73,0,0,1-.6.39,1.9,1.9,0,0,1-1.43,0,1.65,1.65,0,0,1-.6-.41,1.81,1.81,0,0,1-.41-.66A2.36,2.36,0,0,1,14,12.4a2.56,2.56,0,0,1,.16-.92,2.2,2.2,0,0,1,.42-.66,1.8,1.8,0,0,1,.61-.4,1.93,1.93,0,0,1,1.42,0,1.66,1.66,0,0,1,.61.4,2.17,2.17,0,0,1,.41.66,2.39,2.39,0,0,1,.15.93A2.36,2.36,0,0,1,17.63,13.34Z"
          />
          <path
            className={`LocalsearchLogo__st1${color}`}
            d="M24.34,10.35a2,2,0,0,0-.73.14,1.62,1.62,0,0,0-.6.4,1.85,1.85,0,0,0-.41.65,2.28,2.28,0,0,0-.16.89,2.5,2.5,0,0,0,.15.9A2.15,2.15,0,0,0,23,14a1.77,1.77,0,0,0,.61.41,1.94,1.94,0,0,0,.73.14,2,2,0,0,0,.67-.11,1.81,1.81,0,0,0,.51-.3,1.65,1.65,0,0,0,.35-.4,2.66,2.66,0,0,0,.19-.44l1.76.59a3.1,3.1,0,0,1-.4.92,3.39,3.39,0,0,1-.72.8,4.09,4.09,0,0,1-1,.57,3.77,3.77,0,0,1-1.34.21,3.94,3.94,0,0,1-1.53-.3A3.73,3.73,0,0,1,20.73,14a3.9,3.9,0,0,1-.3-1.58,4.09,4.09,0,0,1,.3-1.59,3.72,3.72,0,0,1,.82-1.25,4,4,0,0,1,1.23-.81,4,4,0,0,1,1.52-.29,3.84,3.84,0,0,1,1.36.23,3.52,3.52,0,0,1,1,.57,3,3,0,0,1,.71.8,3.69,3.69,0,0,1,.39.93l-1.8.6a2,2,0,0,0-.52-.87A1.56,1.56,0,0,0,24.34,10.35Z"
          />
          <path
            className={`LocalsearchLogo__st2${color}`}
            d="M38.33,22.29H8.92v-2H38.33Z"
          />
          <image
            className="santaLocalsearch-4"
            width="89"
            height="80"
            transform="translate(-2.68 9.98) scale(0.24)"
            xlinkHref="data:image/png;base64,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"
          />
          <path
            className="santaLocalsearch-11"
            d="M3.6,18.12a.53.53,0,0,0-.12-.79,3.15,3.15,0,0,0-1.43-.28s.51-.55,0-1a2.41,2.41,0,0,0-1-.51s.53-.16.08-.87a6,6,0,0,0-.73-.89s1,.31,1.37.07a.59.59,0,0,0,.26-.62,2.58,2.58,0,0,0,1.31.37.68.68,0,0,0,.52-.59s.79.68,1.28.64.52-.51.52-.51a2,2,0,0,0,1.17,1A.7.7,0,0,0,7.66,14a1.83,1.83,0,0,0,.64,1.21c.53.34.8,0,.8,0a1.09,1.09,0,0,0,.2,1.14c.48.45.56,0,.56,0s.72,2.26-.68,2.7l-.94.23a6.86,6.86,0,0,0-1.75-.56c-.49,0-1,.06-1,.06s.07-.28-.41-.51A3.8,3.8,0,0,0,3.6,18.12Z"
          />
          <path
            className="santaLocalsearch-11"
            d="M3,25.62s.73-.85.57-1.43-.75-.53-.75-.53.58-.28.61-.74a2.29,2.29,0,0,0-.32-1.05s1-.06,1.19-.58a.65.65,0,0,0-.16-.8,2.23,2.23,0,0,0,1.14-.55.47.47,0,0,0-.1-.7,1.12,1.12,0,0,0,1-.59c.24-.58,0-.68,0-.68l2.6.68.87,1.73a1.1,1.1,0,0,0-.24.65c0,.35.48.81.48.81a1.33,1.33,0,0,0-.71.49,1.73,1.73,0,0,0,0,1.12.72.72,0,0,0-1,.16,2.35,2.35,0,0,0-.44,1.24,1.38,1.38,0,0,0-1.23-.24,1.92,1.92,0,0,0-.83,1,1.35,1.35,0,0,0-.94-.5A6.35,6.35,0,0,0,3,25.62Z"
          />
          <path
            className="santaLocalsearch-11"
            d="M13.32,26.09a1.52,1.52,0,0,0-.7-1,.71.71,0,0,0-.9.12,1.58,1.58,0,0,0-.43-1,.75.75,0,0,0-.72-.13,1.72,1.72,0,0,0-.28-.95.85.85,0,0,0-.69-.34,1.18,1.18,0,0,0,.06-1,2.07,2.07,0,0,0-.47-.57l-.44-1.75,1.05-1.7L11,17.46s.7.72,1.27.69c0,0-.21.27.32.63a2.05,2.05,0,0,0,1,.37.43.43,0,0,0-.12.62,4.64,4.64,0,0,0,1.17.88s-.57.16-.42.57,1.17,1.16,1.17,1.16-.7,0-.7.58.84,1.35.84,1.35a1,1,0,0,0-.75.5c-.19.39.11,1.23.11,1.23a3.14,3.14,0,0,0-.9-.38C13.64,25.61,13.32,26.09,13.32,26.09Z"
          />
          <g className="santaLocalsearch-12">
            <path
              className="santaLocalsearch-13"
              d="M11.85,22c-.63-1.16-1.26-2.65-1.62-3.45S9.8,18,10,17.8s.14.07.43.68a37.47,37.47,0,0,0,1.87,3.95c1,1.69,1.66,2.5,1.54,2.49A18.32,18.32,0,0,1,11.85,22Z"
            />
            <path
              className="santaLocalsearch-13"
              d="M12.66,21.86c.4,0,.67-.18.59-.17a2.67,2.67,0,0,1-.63.07,5.19,5.19,0,0,1-.81-.16,1,1,0,0,0,.07.17A2.91,2.91,0,0,0,12.66,21.86Z"
            />
            <path
              className="santaLocalsearch-13"
              d="M13.38,23.18a2,2,0,0,1-.7-.09l-.11-.17a3.14,3.14,0,0,0,.8.16c.31,0,.53-.07.55,0A1.07,1.07,0,0,1,13.38,23.18Z"
            />
            <path
              className="santaLocalsearch-13"
              d="M12.15,20.4a1.9,1.9,0,0,1-1-.09,1.83,1.83,0,0,0-.1-.2,1.76,1.76,0,0,0,1,.19c.48-.06.56-.12.56-.08A1.45,1.45,0,0,1,12.15,20.4Z"
            />
            <path
              className="santaLocalsearch-13"
              d="M11.65,22.9a2.7,2.7,0,0,1,.36-.73l.08.11a4.41,4.41,0,0,0-.31.56c-.12.29-.16.65-.19.6A1,1,0,0,1,11.65,22.9Z"
            />
            <path
              className="santaLocalsearch-13"
              d="M12.57,24.56a1.65,1.65,0,0,1,0-.66,2.11,2.11,0,0,1,.2-.51l.06.13a2.16,2.16,0,0,0-.17.46C12.6,24.27,12.61,24.61,12.57,24.56Z"
            />
            <path
              className="santaLocalsearch-13"
              d="M10.84,21.4a6.64,6.64,0,0,1,.39-.63l.1.09s-.17.23-.33.47a6.71,6.71,0,0,0-.32.67C10.62,22,10.7,21.64,10.84,21.4Z"
            />
            <path
              className="santaLocalsearch-13"
              d="M4.34,24.39c0-.06,2-2,2.36-2.47S10,17.72,10,17.72l.18.15S9.1,19.33,7.54,21.23A16.66,16.66,0,0,1,4.34,24.39Z"
            />
            <path
              className="santaLocalsearch-13"
              d="M2,14.57c.06,0,2.54,1.22,3.11,1.43.41.16,2.44.81,3.46,1.14l1.58.57L10,18,8.4,17.43C7.93,17.27,7.18,17,6,16.57A16.8,16.8,0,0,1,2,14.57Z"
            />
            <path
              className="santaLocalsearch-13"
              d="M6,21.83a2.45,2.45,0,0,1-1-.06c0-.06.58.05,1.21-.08a8.24,8.24,0,0,0,1-.27L7,21.63A6.13,6.13,0,0,1,6,21.83Z"
            />
            <path
              className="santaLocalsearch-13"
              d="M8.19,19a2.36,2.36,0,0,1-1-.15,7.7,7.7,0,0,0,1.22,0,6.87,6.87,0,0,0,1-.17l-.16.19A5,5,0,0,1,8.19,19Z"
            />
            <path
              className="santaLocalsearch-13"
              d="M4.74,16.78a2.38,2.38,0,0,1-1,.06c0-.06.58,0,1.19-.22.31-.11.55-.2.7-.27s.18.1.18.1A6.41,6.41,0,0,1,4.74,16.78Z"
            />
            <path
              className="santaLocalsearch-13"
              d="M5.19,23.06A5.87,5.87,0,0,0,6,22.8l.23-.24a4.42,4.42,0,0,1-1,.37,8.08,8.08,0,0,0-.89.18A2.12,2.12,0,0,0,5.19,23.06Z"
            />
            <path
              className="santaLocalsearch-13"
              d="M5.08,15.43a7.64,7.64,0,0,0,.36.72l.28.19a3.88,3.88,0,0,1-.5-.9c-.22-.56-.27-.92-.3-.87A2.1,2.1,0,0,0,5.08,15.43Z"
            />
            <path
              className="santaLocalsearch-13"
              d="M3.31,14.88a4.51,4.51,0,0,0,.27.49l.19.08a5.06,5.06,0,0,1-.37-.56c-.14-.26-.22-.65-.23-.59A1.31,1.31,0,0,0,3.31,14.88Z"
            />
            <path
              className="santaLocalsearch-13"
              d="M6.41,17.31A3,3,0,0,0,7,17l.2-.13,0-.12s0,0-.17.09a4.87,4.87,0,0,1-.67.36c-.55.24-.91.3-.86.33A2.67,2.67,0,0,0,6.41,17.31Z"
            />
            <path
              className="santaLocalsearch-13"
              d="M3.33,15.8c.25,0,.38,0,.47,0l.26,0L4,15.63s0,0-.14,0a3.26,3.26,0,0,1-.55.08,5.42,5.42,0,0,0-.67,0A2,2,0,0,0,3.33,15.8Z"
            />
            <path
              className="santaLocalsearch-13"
              d="M6,23.3a3.78,3.78,0,0,1,.16-.64l.26-.23a3.5,3.5,0,0,0-.31.95c0,.35,0,.62,0,.61A1.7,1.7,0,0,1,6,23.3Z"
            />
            <path
              className="santaLocalsearch-13"
              d="M7.15,20.45A2.43,2.43,0,0,1,6,20.32c0-.05.48.07,1.16,0A3.26,3.26,0,0,0,8.27,20l-.15.24A5.94,5.94,0,0,1,7.15,20.45Z"
            />
            <path
              className="santaLocalsearch-13"
              d="M8.47,21.1A4,4,0,0,1,8.36,20l.23-.18A3.09,3.09,0,0,0,8.53,21c.09.5.3.87.24.84A2.43,2.43,0,0,1,8.47,21.1Z"
            />
            <path
              className="santaLocalsearch-13"
              d="M7.22,22.51a3.24,3.24,0,0,1-.1-.84l.19-.23a3.48,3.48,0,0,0,0,1c.11.48.19.6.16.66S7.27,22.78,7.22,22.51Z"
            />
            <path
              className="santaLocalsearch-13"
              d="M6.51,15.84a3.44,3.44,0,0,0,.29.8l.27.13a3.29,3.29,0,0,1-.44-.95c-.12-.48-.09-.62-.15-.67S6.45,15.58,6.51,15.84Z"
            />
            <path
              className="santaLocalsearch-13"
              d="M8.1,16.4a3.87,3.87,0,0,0,.25.82l.27.13a3.29,3.29,0,0,1-.4-1c-.1-.48-.07-.62-.12-.67S8.05,16.14,8.1,16.4Z"
            />
          </g>
          <path
            className="santaLocalsearch-14"
            d="M11.66,20.3a1.28,1.28,0,0,0-.35-1.9,1.3,1.3,0,0,0-1.86.22,1.36,1.36,0,0,0,.18,1.95A1.45,1.45,0,0,0,11.66,20.3Z"
          />
          <path
            className="santaLocalsearch-15"
            d="M10.06,20.08c-.22-.18-.4-.47-.49-.45s-.11.5.37.82.65.12.65,0S10.29,20.27,10.06,20.08Z"
          />
          <path
            className="santaLocalsearch-16"
            d="M11.26,20.13c.14,0,.27-.24.18-.32S11.18,20.11,11.26,20.13Z"
          />
          <path
            className="santaLocalsearch-14"
            d="M9.4,18.65a1.28,1.28,0,0,0-.34-1.9,1.25,1.25,0,0,0-1.8.24,1.28,1.28,0,0,0,.22,1.81A1.34,1.34,0,0,0,9.4,18.65Z"
          />
          <path
            className="santaLocalsearch-15"
            d="M7.86,18.39c.24.2.53.25.55.36s-.54.19-.86-.13-.32-.69-.23-.72S7.52,18.11,7.86,18.39Z"
          />
          <path
            className="santaLocalsearch-16"
            d="M7.6,17.12c0-.05.05-.13.15-.17A.21.21,0,0,1,8,17C8,17.05,7.63,17.21,7.6,17.12Z"
          />
          <path
            className="santaLocalsearch-17"
            d="M11.93,17.64a1.24,1.24,0,0,0-.3-1.85A1.33,1.33,0,0,0,9.75,16a1.26,1.26,0,0,0,.15,1.88A1.35,1.35,0,0,0,11.93,17.64Z"
          />
          <path
            className="santaLocalsearch-15"
            d="M10.35,17.41c.26.18.54.25.55.36s-.38.21-.75-.06-.38-.7-.3-.74S10,17.16,10.35,17.41Z"
          />
          <path
            className="santaLocalsearch-16"
            d="M11.27,16.3c0-.06,0-.15-.14-.2s-.19-.06-.23,0S11.24,16.36,11.27,16.3Z"
          />
        </g>
      </g>
    </svg>
  );
}

LocalLogo.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  color: PropTypes.string,
};

LocalLogo.defaultProps = {
  width: 50,
  height: 34,
  color: '',
};

export default LocalLogo;
